import React from 'react';
import LabelValue from 'components/customer/PDF/components/LabelValue';
import Excel from 'shared/Excel';
import {cloneDeep} from 'lodash';
import ImageField from 'components/customer/PDF/components/ImageField';

interface Props {
    headerText: string;
    fields: {
        field: string;
        label: string;
        invertYes?: boolean;
        conditions?: {expression: string; value: string}[];
        type?: 'label-value' | 'image';
    }[];
    data: {[key: string]: string | number};
    hasDivider?: boolean;
    lgValue?: boolean;
    gap?: string;
}

const Section = ({
    headerText,
    fields,
    data,
    hasDivider = true,
    lgValue,
    gap = '10px 20px',
}: Props) => {
    if (!fields || fields.every(({field}) => !(field in data))) {
        return null;
    }
    return (
        <section>
            {hasDivider ? <div className="hr mt-5" /> : null}
            <div className="font-sm mt-5">
                <strong>{headerText}:</strong>
            </div>

            <div className="flex" style={{gap, flexWrap: 'wrap'}}>
                {fields.map(
                    ({
                        label,
                        field,
                        invertYes,
                        conditions,
                        type = 'label-value',
                    }) => {
                        let value = data[`${field}`];
                        if (!!value && invertYes) {
                            value = value === 'Yes' ? 'No' : 'Yes';
                        }
                        if (conditions && conditions.length) {
                            const mapData = cloneDeep(data);
                            Object.keys(mapData).map((key) => {
                                const dataValue =
                                    mapData[key as keyof typeof mapData];
                                if (dataValue === 'Yes') {
                                    mapData[key as keyof typeof mapData] = 1;
                                } else if (dataValue === 'No') {
                                    mapData[key as keyof typeof mapData] = 0;
                                }
                            });
                            try {
                                const result = conditions.find(({expression}) =>
                                    Excel.calculate(expression, mapData)
                                );
                                if (result) {
                                    value = result.value;
                                }
                            } catch {
                                // do nothing in case of failure
                                // will display the current value
                            }
                        }
                        let imageLabel: string = null;
                        if (type === 'image') {
                            // image field is currently linking the image label based on the label config
                            // when using image type please set label to correct data mapping
                            const styleField = fields
                                .filter((f) => f.field !== field)
                                .find((f) => f.label === label);
                            imageLabel = styleField
                                ? (data[styleField.field] as string)
                                : '';
                        }
                        return !!value || value == '0' ? (
                            <div
                                key={field}
                                className={
                                    fields.length === 2
                                        ? 'flex-col flex-1'
                                        : 'flex-col'
                                }>
                                {type === 'label-value' ? (
                                    <LabelValue
                                        label={label}
                                        value={value}
                                        lgValue={lgValue}
                                        valueColour={
                                            field == 'VariationRequest'
                                                ? 'red'
                                                : ''
                                        }
                                    />
                                ) : null}
                                {type === 'image' ? (
                                    <ImageField
                                        imageSrc={`${value}`}
                                        imageLabel={imageLabel}
                                        field={field}
                                    />
                                ) : null}
                            </div>
                        ) : null;
                    }
                )}
            </div>
        </section>
    );
};

export default Section;
